import {
  Box,
  Typography,
  Container,
  Divider,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
  getOrdersByOrderBookingIdAction,
  getPoOrderDetailsAction,
} from './Action';
import { useLocation, useNavigate } from 'react-router-dom';
import { getOrderFinalStatusById, getRGBAColor } from '../../utils/settings';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import moment from 'moment';

function AttachedOrders() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orderID } = state;
  const [orderList, setOrderList] = useState([]);

  const getOrderByOrderBookingId = async () => {
    const { data, error, message } = await getOrdersByOrderBookingIdAction({
      order_id: orderID,
    });
    if (!error) {
      setOrderList(data);
    } else {
      toast.error(message);
    }
  };
  useEffect(() => {
    getOrderByOrderBookingId();
  }, []);

  return (
    <Container
      maxWidth='true'
      sx={{
        pl: '2rem',
        pt: '2rem',
        height: window.innerHeight,
        overflowY: 'auto',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Typography variant='h5'>Attached Orders</Typography>
      <Divider sx={{ mt: '1rem', mb: '1rem' }} />
      <Typography variant='h6'>Order Booking ID: {orderID}</Typography>
      <Box sx={{ height: '1rem' }} />
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell align='center'>#</TableCell>
                <TableCell align='center'>Order Id</TableCell>
                <TableCell align='center'>Date</TableCell>
                <TableCell align='center'>Ship To Party</TableCell>
                <TableCell align='center'>Booking Qty</TableCell>
                <TableCell align='center'>Delivered Qty</TableCell>
                <TableCell align='center'>Pending Qty</TableCell>
                <TableCell align='center'>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderList.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    cursor: 'pointer',
                  }}
                  onClick={async () => {
                    const { data, error, message } =
                      await getPoOrderDetailsAction({
                        order_id: row.order_id,
                      });

                    if (!error) {
                      dispatch({
                        type: 'SET_EDIT_PO_BOOKING_DETAILS',
                        data: data,
                      });

                      dispatch({
                        type: 'IS_SECONDARY_ORDER',
                        data: false,
                      });

                      navigate('/order-booking/dispatch-status-details', {
                        state: {
                          orderID: row.order_id,
                        },
                      });
                    } else {
                      return toast.error(message);
                    }
                  }}
                >
                  <TableCell align='center'>{index + 1}</TableCell>
                  <TableCell align='center'>
                    <Box>{row.order_id}</Box>
                  </TableCell>
                  <TableCell align='center'>
                    {moment(row?.order_date).format('DD MMM YYYY')}
                  </TableCell>
                  <TableCell align='center'>
                    {row.ship_to_party_details}
                  </TableCell>

                  <TableCell align='center'>{`${row.order_total_quantity.quantity_in_metric_ton} ${row.order_total_quantity.unit}`}</TableCell>
                  <TableCell align='center'>{`${row.order_delivered_quantity.quantity_in_metric_ton} ${row.order_delivered_quantity.unit}`}</TableCell>
                  <TableCell align='center'>{`${row.order_remaining_quantity.quantity_in_metric_ton} ${row.order_remaining_quantity.unit}`}</TableCell>
                  <TableCell
                    sx={{
                      width: '10rem',
                    }}
                    align='center'
                  >
                    <Box
                      sx={{
                        borderRadius: '10px',
                        padding: '0.5rem',
                        textAlign: 'center',
                        backgroundColor: getRGBAColor(
                          getOrderFinalStatusById(row?.final_status).color,
                        ),
                      }}
                    >
                      <Typography
                        sx={{
                          color: getOrderFinalStatusById(row?.final_status)
                            .color,
                          fontWeight: 'bold',
                          fontSize: '0.8rem',
                        }}
                      >
                        {getOrderFinalStatusById(row?.final_status).name}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
}

export default AttachedOrders;
